import React from 'react';

import Style from './subsection.module.css';

export function Subsection({ children, className = '' }) {
    return <div className={`${Style['subsection']} ${className}`}>{children}</div>;
}
